import { render, staticRenderFns } from "./house.vue?vue&type=template&id=8e245d2e&scoped=true&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"
import style0 from "./house.vue?vue&type=style&index=0&id=8e245d2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e245d2e",
  null
  
)

export default component.exports